'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContentCard = require('./ContentCard.css');

var _ContentCard2 = _interopRequireDefault(_ContentCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentCard = function ContentCard(props) {
  return _react2.default.createElement(
    'div',
    {
      className: 'jsx-' + _ContentCard2.default.__scopedHash + ' ' + 'card'
    },
    props.children,
    _react2.default.createElement(_style2.default, {
      styleId: _ContentCard2.default.__scopedHash,
      css: _ContentCard2.default.__scoped
    })
  );
};

ContentCard.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = ContentCard;